// extracted by mini-css-extract-plugin
export default {"tupacGrid":"ym-z","tupacHeader":"zm-z","tupacHeader2":"Am-z","tupacMenu":"Bm-z","tupacMenu2":"Cm-z","tupacMain":"Dm-z","tupacMain2":"Em-z"};